import {
  Backdrop,
  Button,
  CircularProgress,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "hooks/storeHook";
import {
  TRAINING_ASYNC_ALL,
  TRAINING_CHANGED_EVENTS,
  TRAINING_DELETE_ID,
} from "store/reducers/trainings/trainings.reducer";
import { useNavigate } from "react-router-dom";

const TrainingPage: React.FC = () => {
  const trainingsState = useAppSelector((state) => state.trainings);
  const dispatch = useAppDispatch();
  const Navigation = useNavigate();

  const [deleteModal, setDeleteModal] = React.useState({ id: 0, open: false });
  const handleClickOpen = (id: number) => {
    setDeleteModal({
      open: true,
      id: id,
    });
  };
  const handleClose = () => {
    setDeleteModal({
      open: false,
      id: 0,
    });
  };
  const handleDeleteUser = () => {
    //console.log(deleteModal.id);
    handleClose();
    dispatch(TRAINING_DELETE_ID({ id: deleteModal.id }));
    dispatch(TRAINING_ASYNC_ALL());
  };

  const handleChange = (e: { target: { value: string } }) => {
    //console.log(e.target.value);
    dispatch(TRAINING_CHANGED_EVENTS({ page: 0, search: e.target.value }));
    dispatch(TRAINING_ASYNC_ALL());
  };

  React.useEffect(() => {
    dispatch(TRAINING_ASYNC_ALL());
  }, []);

  const columns: GridColDef[] = [
    {
      field: "active",
      headerName: "Ativo",
      width: 70,
      renderCell: (params: GridRenderCellParams<Boolean>) => (
        <strong>{`${params.value ? "Ativo" : "Inativo"}`}</strong>
      ),
    },
    { field: "type", headerName: "Tipo", width: 110 },
    { field: "name", headerName: "Nome", width: 220 },
    {
      field: "startDate",
      headerName: "Início",
      width: 105,
      renderCell: (params: GridRenderCellParams<Date>) => {
        const datatime = new Date(params.value);
        return (
          <div>
            {`${datatime.getDate().toString().padStart(2, "0")}/${(
              datatime.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}/${datatime.getFullYear()}`}
          </div>
        );
      },
    },
    {
      field: "endDate",
      headerName: "Final",
      width: 105,
      renderCell: (params: GridRenderCellParams<Date>) => {
        const datatime = new Date(params.value);
        return (
          <div>
            {`${datatime.getDate().toString().padStart(2, "0")}/${(
              datatime.getMonth() + 1
            )
              .toString()
              .padStart(2, "0")}/${datatime.getFullYear()}`}
          </div>
        );
      },
    },
    { field: "registrationsCount", headerName: "Registrados", width: 120 },
    {
      field: "id",
      headerName: "Ações",
      width: 260,
      renderCell: (params: GridRenderCellParams<number>) => (
        <>
          <Button
            variant="contained"
            color="info"
            size="small"
            style={{ marginLeft: 10 }}
            onClick={() => {
              trainingsState.trainings.map((item) => {
                if (item.id === Number(params.value)) {
                  dispatch(TRAINING_CHANGED_EVENTS({ training: item }));
                }
              });
              Navigation(`/events/${params.value}/registereds`);
            }}
          >
            Ver
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            style={{ marginLeft: 16 }}
            onClick={() => {
              trainingsState.trainings.map((item) => {
                if (item.id === Number(params.value)) {
                  dispatch(TRAINING_CHANGED_EVENTS({ training: item }));
                }
              });
              Navigation(`/events/edit/${params.value}`);
            }}
          >
            Editar
          </Button>
          <Button
            variant="contained"
            color="error"
            size="small"
            style={{ marginLeft: 10 }}
            onClick={() => handleClickOpen(params.value)}
          >
            Excluir
          </Button>
        </>
      ),
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "85vh",
        background: (theme) => theme.palette.background.default,
      }}
    >
      <Typography variant="h5">Eventos</Typography>
      <Box sx={{ width: "90%", height: "70px", margin: "0 auto" }}>
        <TextField
          type="text"
          label="Pesquisar"
          fullWidth
          onChange={handleChange}
        />
      </Box>
      <Box sx={{ width: "90%", height: "95%", margin: "0 auto" }}>
        <DataGrid
          rows={trainingsState.trainings}
          columns={columns}
          pagination
          paginationMode="server"
          rowsPerPageOptions={[6, 10, 20]}
          pageSize={trainingsState.pageSize}
          page={trainingsState.page}
          rowCount={trainingsState.count}
          loading={trainingsState.loading}
          onPageChange={(_page) => {
            dispatch(TRAINING_CHANGED_EVENTS({ page: _page }));
            dispatch(TRAINING_ASYNC_ALL());
          }}
          onPageSizeChange={(_size) => {
            dispatch(TRAINING_CHANGED_EVENTS({ pageSize: _size }));
            dispatch(TRAINING_ASYNC_ALL());
          }}
        />
      </Box>
      {trainingsState.loading && (
        <Backdrop
          sx={{
            bgColor: "#3333",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={trainingsState.loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog
        open={deleteModal.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja realmente excluir ?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Removerá o treinamento
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleDeleteUser} autoFocus>
            Remover
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TrainingPage;
